import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  branchName: null,
  storeClose: null,
  workingTime: null,
  location: null,
  cashless: null,
  fc: null,
};

// Slice
const storeInfoSlice = createSlice({
  name: "storeInfo",
  initialState,
  reducers: {
    getInfo(state) {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    },
    setInfo(state, action) {
      const {
        branchName,
        isOpen,
        storeClose,
        workingTime,
        location,
        cashless,
        fc,
      } = action.payload;
      return {
        ...state,
        branchName,
        isOpen,
        storeClose,
        workingTime,
        location,
        cashless,
        fc,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { getInfo, setInfo, fetchDataSuccess, fetchDataFailure } =
  storeInfoSlice.actions;

export default storeInfoSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });

    const response = yield call(apiService.post, apiUrl, headers);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const {
        storeName,
        storeTime,
        storeClose,
        cashlessYN,
        fcYN,
        address1,
        address2 = "",
      } = response.data;
      yield put(
        setInfo({
          branchName: storeName,
          workingTime: storeTime,
          storeClose,
          location: { address1, address2 },
          cashless: cashlessYN,
          fc: fcYN,
        })
      );
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* storeInfoSaga() {
  yield takeLatest(getInfo.type, fetchDataSaga);
}
